__turbopack_context__.v({
  "errorText": "currencyinput-module-scss-module__RcDvKW__errorText",
  "errorWrapper": "currencyinput-module-scss-module__RcDvKW__errorWrapper",
  "focusWrapper": "currencyinput-module-scss-module__RcDvKW__focusWrapper",
  "homePrequalCurrency": "currencyinput-module-scss-module__RcDvKW__homePrequalCurrency",
  "input": "currencyinput-module-scss-module__RcDvKW__input",
  "wrapper": "currencyinput-module-scss-module__RcDvKW__wrapper",
  "wrapperPL": "currencyinput-module-scss-module__RcDvKW__wrapperPL",
});
